// Clipboard writing is initiated only by a visitor's explicit copy action.
export async function copyText(value:string):Promise<boolean>{
 if(window.isSecureContext&&navigator.clipboard){
  try{await navigator.clipboard.writeText(value);return true;}catch{/* Allow manual copy on restricted browsers. */}
 }
 const previous=document.activeElement as HTMLElement|null;
 const field=document.createElement('textarea');field.value=value;field.readOnly=true;
 field.style.cssText='position:fixed;left:-9999px;top:0;opacity:0;';document.body.append(field);
 try{field.select();field.setSelectionRange(0,value.length);return document.execCommand('copy');}
 catch{return false;}
 finally{field.remove();previous?.focus();}
}
